import { getBrand } from '../../../pages/api';

const gssp = async (context) => {
  const { query: { brand = '' } } = context;
  const response = await getBrand({ brand, context });
  const data = response.taxons[0];
  if (data) {
    return { brand: data };
  }
  return { noResults: true };
};

export default gssp;
